import React from "react";

const ChatItem = ({ position, data, handleRemove }) => {
	return (
		<li className={`${position} clearfix`} style={{ postition: "relative" }}>
			{/* {position === "right" && (
				<button
					className="btn btn-link"
					onClick={() => handleRemove(data.conversation_id, data.dm_id)}
					style={{ position: "absolute", zIndex: 999, left: "40px" }}
					title="Remove this message"
				>
					<i className="fa fa-trash" />
				</button>
			)} */}
			<span className={`chat-img pull-${position}`}>
				<img src="https://bootdey.com/img/Content/user_3.jpg" alt="" />
			</span>
			<div className="chat-body clearfix">
				<div className="chat-body-header">
					<strong className="primary-font">{data.user.user_nama}</strong>
					<small className="pull-right text-muted">
						<i className="fa fa-clock-o" /> {data.conversation_date}
					</small>
				</div>
				<p style={{ margin: "10px 0" }}>{data.conversation_text}</p>
			</div>
		</li>
	);
};

export default ChatItem;



// WEBPACK FOOTER //
// ./src/views/Chat/components/ChatItem.js